module.exports = __webpack_public_path__ + "static/media/a-year-in-books-2020.4daa560f.md";